export default {
baseurl: "https://businesssistepanel.dev-hi.xyz/api",
};
